import {
  mapGetters
} from 'vuex'

import * as modalStore from '@/store/modals'

export {
  modalStore
}

export const createModalMixin = (modalType) => {
  const getters = mapGetters(modalStore.moduleName, Object.keys(modalStore.getterTypes))

  return {
    methods: {
      openCurrentModal () {
        this.$modals.open(modalType)
      },
      closeCurrentModal () {
        this.$modals.close()
      }
    },
    computed: {
      ...getters
    }
  }
}
